import {
	SET_DEPARTMENTS,
	SET_DEPARTMENT,
	CLEAR_DEPARTMENTS,
	CLEAR_DEPARTMENT,
	ADD_DEPARTMENT,
	UPDATE_DEPARTMENT,
	REMOVE_DEPARTMENT,
} from './actionTypes';

export const department = (state = {}, action) => {
	switch (action.type) {
		case SET_DEPARTMENT:
			return action.payload;
		case UPDATE_DEPARTMENT:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_DEPARTMENT:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_DEPARTMENTS:
			return action.payload;
		case ADD_DEPARTMENT:
			return [...state, action.payload];
		case UPDATE_DEPARTMENT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_DEPARTMENT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_DEPARTMENTS:
			return [];
		default:
			return state;
	}
};
